import { render, staticRenderFns } from "./FilePDFIcon.vue?vue&type=template&id=716ab996&scoped=true"
var script = {}
import style0 from "./FilePDFIcon.vue?vue&type=style&index=0&id=716ab996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716ab996",
  null
  
)

export default component.exports